import _ from 'lodash';
import React, { Component } from 'react';

import { formatNewLines } from '../../util';

import { getIcon } from '../../util/icons';

class TalentDefinitions extends Component {

  getGoalProgress(goal){
    const { goalValue } = goal;

    if(!goalValue || (!goalValue.practiced && !goalValue.applied && !goalValue.improved)){
      return(
        <div className="progress">
          <p>No progress this week</p>
        </div>
      );
    }


    const checkIcon = getIcon('check');

    const practicedDescription = (goal.goalMeta || {}).practicedHow ? (goal.goalMeta || {}).practicedHow : '';
    const appliedDescription = (goal.goalMeta || {}).appliedHow ? (goal.goalMeta || {}).appliedHow : '';
    const improvedDescription = (goal.goalMeta || {}).improvedHow ? (goal.goalMeta || {}).improvedHow : '';

    return (
      <div className="progress">
        {goalValue.practiced &&
          <div>{getIcon('check')}<p><b>Worked on this week</b><br/>{practicedDescription}</p></div>
        }
        {goalValue.applied &&
          <div>{getIcon('check')}<p><b>Applied this week</b><br/>{appliedDescription}</p></div>
        }
        {goalValue.improved &&
          <div>{getIcon('check')}<p><b>Improved this week</b><br/>{improvedDescription}</p></div>
        }
      </div>
    );
  }

  renderGoal(goal){

    if(!(goal.category === 'behavior' || goal.category === 'skill')){
      return null;
    }

    const { smartGoal, actionPlan } = (goal.goalMeta || {});

    //const userName = this.props.userData.firstName;

    return (
      <li className="talent" key={goal.id}>
        <h3>{goal.name}</h3>
        <p className="definition" dangerouslySetInnerHTML={{ __html: formatNewLines(goal.definition) }}></p>
        <h6>SMART GOAL</h6>
        <p className="definition" dangerouslySetInnerHTML={{ __html: formatNewLines((smartGoal && smartGoal !== '') ? smartGoal : 'Not set') }}></p>
        <h6>ACTION PLAN</h6>
        <p className="definition" dangerouslySetInnerHTML={{ __html: formatNewLines((actionPlan && actionPlan !== '') ? actionPlan : 'Not set') }}></p>
        <h6>PROGRESS THIS WEEK</h6>
        {this.getGoalProgress(goal)}
      </li>
    )
  }

  render(){

    const { sprintData, userData } = this.props;

    return(
      <div className="break-page sprint-talent-definitions">
        <h1>Talent Recap</h1>
        <ul className="talents">
          {_.map(sprintData.goals, goal => { return this.renderGoal(goal); })}
        </ul>
      </div>
    );
  }
}

export default TalentDefinitions;



// WEBPACK FOOTER //
// ./src/components/sprint/talentDefinitions.js